// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetAccountRequestModel {
    static getAttributeTypeMap() {
        return GetAccountRequestModel.attributeTypeMap;
    }
}
GetAccountRequestModel.discriminator = undefined;
GetAccountRequestModel.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    }
];
//# sourceMappingURL=getAccountRequestModel.js.map